// extracted by css-extract-rspack-plugin
export default {"dashboardTabSelectContainer":"p1F9f"};